<template>
  <div class="is-marginless is-paddingless section">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ getTitle }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"></app-breadcrumb>
            </div>
          </div>
        </div>
      </div>
      <div class="tab is-marginless">
        <ul>
          <router-link :to="{ name: 'l.bodac.relance-listeDesRetards' }"
                       :class="{'text-access-no-permission':
                                   !checkPermissions(permRelance.lecture)}">
            <li :class="{'is-active': $router.currentRoute.name
            === 'l.bodac.relance-listeDesRetards'}">
              {{ $t('relance.retards') }}
            </li>
          </router-link>
          <router-link :to="{ name: 'l.bodac.relance-listeRelancesSave' }"
                       :class="{'text-access-no-permission':
                                   !checkPermissions(permRelance.lecture)}">
            <li :class="{'is-active': $router.currentRoute.name
            === 'l.bodac.relance-listeRelancesSave'}">
              {{ $t('relanceSave.title') }}
            </li>
          </router-link>
        </ul>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import { RELANCE } from '@/configuration/permissionsBodacConf';

const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'l_retardPaiement',
  data() {
    return {
      permRelance: RELANCE,
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    getTitle() {
      switch (this.$router.currentRoute.name) {
        case 'l.bodac.relance-listeDesRetards':
          return this.$t('relance.titleRetard');
        default:
          return this.$t('relance.titleRelances');
      }
    },
    breadcrumb() {
      return [
        { title: this.$t('listeClients.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.getTitle, route: '', isActive: true },
      ];
    },
  },
  components: {
    appBreadcrumb: breadcrumb,
  },
  mounted() {
    this.setInformationPage(this.$t('pageGescom.retard.listeRelance'));
  },
};
</script>

<style scoped>

</style>
